import { render, staticRenderFns } from "./CmgRewardExtrasWelcomeCard.vue?vue&type=template&id=e6ea4f50&scoped=true&lang=pug"
import script from "./cmg-reward-extras-welcome-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-extras-welcome-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardExtrasWelcomeCard.vue?vue&type=style&index=0&id=e6ea4f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ea4f50",
  null
  
)

export default component.exports